import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../material/material.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { ImageZoneSelectorComponent } from './image-zone-selector/image-zone-selector.component';
import { SelectedChipsComponent } from './selected-chips/selected-chips.component';

@NgModule({
  declarations: [ImageZoneSelectorComponent, SelectedChipsComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    NgbModule,
    ImageZoneSelectorComponent,
    SelectedChipsComponent
  ]
})
export class SharedModule { }
